import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postExchangeRate } from '../../../../actions';
import { EXCHANGE_RATE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import ExchangeRateForm from './ExchangeRateForm';

const NewExchangeRate = ({ breadcrumbs, dispatchpostExchangeRate }) => {
  const onSubmit = (formValues) =>
    dispatchpostExchangeRate({
      ...formValues,
      currency: formValues.currencyId.value
    });

  const content = <ExchangeRateForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Tasa de Cambio"
      subtitle="Crear una nueva tasa de cambio."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostExchangeRate: postExchangeRate,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tasas de Cambio',
      href: EXCHANGE_RATE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewExchangeRate.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostExchangeRate: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewExchangeRate);
